module.exports = __webpack_public_path__ + "img/mountain.be5030ca.webp";